/* Nutricim — global UI behaviours (menu, toast) */
(function () {
  'use strict';

  // ---- Toast ----
  var toast = document.getElementById('Toast');
  var toastText = document.getElementById('ToastText');
  var toastTimer;
  window.NutricimToast = function (msg) {
    if (!toast) return;
    toastText.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  };

  // ---- Mobile menu ----
  var menu = document.getElementById('MobileMenu');
  function openMenu() { if (menu) menu.classList.add('is-open'); }
  function closeMenu() { if (menu) menu.classList.remove('is-open'); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); closeMenu(); }
  });

  // ---- Product detail: quantity + tabs (progressive enhancement) ----
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-dec]');
    var inc = e.target.closest('[data-qty-inc]');
    if (dec || inc) {
      var wrap = (dec || inc).closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v + (inc ? 1 : -1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var tab = e.target.closest('.tab');
    if (tab) {
      var tabs = tab.closest('.tabs');
      var panelId = tab.getAttribute('aria-controls');
      tabs.querySelectorAll('.tab').forEach(function (t) { t.setAttribute('aria-selected', t === tab); });
      var container = tabs.parentElement;
      container.querySelectorAll('.tab-panel').forEach(function (p) {
        p.hidden = (p.id !== panelId);
      });
    }
  });
})();
